import React from 'react'

const Contact = (props) => (
    <section id="contact">
        <div className="inner">
            <section>
                <form method="post" action="#">
                    <div className="field half first">
                        <label htmlFor="name">Nom</label>
                        <input type="text" name="name" id="name" />
                    </div>
                    <div className="field half">
                        <label htmlFor="email">Email</label>
                        <input type="text" name="email" id="email" />
                    </div>
                    <div className="field">
                        <label htmlFor="message">Missatge</label>
                        <textarea name="message" id="message" rows="6"></textarea>
                    </div>
                    <ul className="actions">
                        <li><input type="submit" value="Enviar missatge" className="special" /></li>
                        <li><input type="reset" value="Esborrar" /></li>
                    </ul>
                </form>
            </section>
            <section className="split">
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-envelope"></span>
                        <h3>Email</h3>
                        <a href="mailto: scoalaikg@gmail.com"> Monica Stanescu : scoalaikg@gmail.com</a><br/>
                        <a href="mailto: d.zamillo@csenprogetti.it">Debora Zamillo: d.zamillo@csenprogetti.it</a><br/>
                        <a href="mailto: vamoros@aalba.cat"> Violant Amoros: vamoros@aalba.cat</a>
                    </div>
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-phone"></span>
                        <h3>Telèfon</h3>
                        <span>+40 31 4257298 </span>
                    </div>
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-home"></span>
                        <h3>Adreça</h3>
                        <span>Constantin Noica 140 Street <br />
                        Bucharest, Sector 6, 060057<br />
                        Romania  </span>
                    </div>
                </section>
            </section>
        </div>
    </section>
)

export default Contact
